<template>
  <div class="list">
    <ul>
      <li v-for="project in projects">
        <router-link v-if="project.hidden!==1" :to="project.slug">
          <span class="space">–</span>{{project.title}}
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    props: ['projects','home']
  };
</script>
<style lang="scss" scoped>
  @import "../global.scss";
  .list {
    @media #{$medium-up} {
      float:left;
      width: 50%;
    }
    .space {
      display: inline-block;
      width: 1.2rem;
      margin-left: 0.3rem;
    }
    padding:1rem;
    .section {
      margin-bottom:1em;
    }
    ul {
      li {
      }
      margin-bottom: 2rem;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/List.vue